module.exports = "/images/gallery-line-top-right-bottom-left.svg?e363fa94b02a46340ca3376ef105da68";